export default "__VITE_ASSET__944023b7__"